import type { ReactNode } from "react";

/** Minimal shape needed for the confirmation summary. */
interface InstructionLike {
  instructionNumber?: string;
  cropTypeName?: string;
  variety?: string;
  trayTypeName?: string;
}

const Row = ({ label, value }: { label: string; value: ReactNode }) => (
  <p className="flex justify-between gap-4">
    <span className="text-muted-foreground">{label}</span>
    <span className="font-medium text-right">{value}</span>
  </p>
);

/**
 * Shared confirmation body for sowing-instruction actions. Shows the
 * instruction number + crop/variety, then any action-specific rows
 * (e.g. "Quantity sown", "Trays germinated").
 */
export const SowingConfirmBody = (
  instruction: InstructionLike,
  extraRows: Array<{ label: string; value: ReactNode }> = []
): ReactNode => {
  const crop = [instruction.cropTypeName, instruction.variety]
    .filter(Boolean)
    .join(" · ");
  return (
    <div className="space-y-0.5">
      {instruction.instructionNumber && (
        <Row label="Instruction" value={instruction.instructionNumber} />
      )}
      {crop && <Row label="Crop" value={crop} />}
      {instruction.trayTypeName && (
        <Row label="Tray type" value={instruction.trayTypeName} />
      )}
      {extraRows.map((r) => (
        <Row key={r.label} label={r.label} value={r.value} />
      ))}
    </div>
  );
};
